import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { Util } from '../Constant/Util';
@Injectable(
  {providedIn: 'root'}
)
export class EncryptDataService {
  encryptSecretKey: any = "N!t!nD@D@Don";
  constructor() { }

  public encryptData(data: any):any {
    try {
      return CryptoJS.AES.encrypt(data, this.encryptSecretKey);
    } catch (e) {
    }
  }

  public decryptData(data: any):any {
    
    try {
      if (Util.isDefinedAndNotNull(data)) {
        const bytes = CryptoJS.AES.decrypt(data, this.encryptSecretKey);
        if (bytes) {
          return bytes.toString(CryptoJS.enc.Utf8);
        }
      }
    } catch (e) {
    }
  }
}
